module.exports = __webpack_public_path__ + "static/media/logout.5ff279a4.svg";